<template>
  <div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <v-flex
      v-if="isLoading"
      justify-center
    >
      <u-loader />
    </v-flex>
    <div v-else>
      <v-card class="card-body">
        <v-container>
          <h5>Kontakt bearbeiten</h5>
          <hr>

          <!-- Organisation-->
          <b-row class="mt-5">
            <label class="mt-4 col-3 defaultLabel"> Organisation </label>
            <div class="col-7 pl-1">
              <v-autocomplete
                v-model="contactObject.organisationId"
                :items="organisation_items"
                clearable
                item-text="name"
                item-value="id"
                label="Organisation"
                no-data-text="Es wurden keine Einträge gefunden"
                placeholder="Nach Organisationen suchen..."
              />
            </div>
          </b-row>

          <!-- Anrede-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Anrede </label>
            <div class="col-7 pl-1">
              <v-autocomplete
                v-model="contactObject.formOfAddressId"
                :items="anreden_items"
                clearable
                item-text="value"
                item-value="formOfAddressId"
                label="Anrede"
                no-data-text="Es wurden keine Einträge gefunden"
                placeholder="Nach Anreden suchen..."
              />
            </div>
            <div
              v-if="$IsUserInRole('KonfigurationContentmanager')"
              class="col-2"
            >
              <v-btn
                color="success"
                dark
                fab
                small
                title="Neue Anrede Erfassen"
                @click="createAnreden"
              >
                <i class="fas fa-plus" />
              </v-btn>
            </div>
          </b-row>

          <!-- Nachname-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Nachname </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="contactObject.lastName"
                label="Nachname"
              />
            </div>
          </b-row>

          <!-- Vorname-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Vorname </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="contactObject.firstName"
                label="Vorname"
              />
            </div>
          </b-row>

          <!-- Email-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Email </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="contactObject.email"
                label="Email"
              />
            </div>
          </b-row>

          <!-- Telefon-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Telefon </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="contactObject.phone"
                label="Telefon"
              />
            </div>
          </b-row>

          <!-- Mobile-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Mobile </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="contactObject.mobilePhone"
                label="Mobile"
              />
            </div>
          </b-row>

          <!-- Kommunikationssprache-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel">
              Kommunikationssprache
            </label>
            <div class="col-7 pl-1">
              <v-autocomplete
                v-model="contactObject.communicationLanguageId"
                :items="communicationLanguage_items"
                clearable
                item-text="name"
                item-value="id"
                label="Kommunikationssprache"
                no-data-text="Es wurden keine Einträge gefunden"
              />
            </div>
          </b-row>
        </v-container>
      </v-card>

      <v-btn
        :disabled="
          !contactObject.formOfAddressId ||
            !contactObject.lastName ||
            !contactObject.communicationLanguageId
        "
        class="btn-left"
        color="success"
        raised
        title="Kontakt Speichern"
        @click="saveEdit"
      >
        <i class="fas fa-save mr-3" /> Speichern
      </v-btn>

      <v-btn
        color="#e72b37"
        raised
        style="color: white"
        title="Erfassen Abbrechen"
        @click="cancelEdit"
      >
        <i class="fas fa-ban mr-3" /> Abbrechen
      </v-btn>
    </div>
  </div>
</template>

<script>
import {
  GetContactsWithId,
  GetFormOfAddress,
  GetOragnisations,
  PutContacts,
} from "@/services/user.crm.service";
import { GetFallbackLanguages } from "@/services/contract.edition.translation.service";

export default {
  data() {
    return {
      isLoading: false,
      contactObject: {},
      anreden_items: [],
      organisation_items: [],
      communicationLanguage_items: [],
      errorObject: null,
    };
  },
  created() {
    this.getFormOfAddress();
  },
  methods: {
    createAnreden() {
      localStorage.contactObject = JSON.stringify(this.contactObject);
      this.$router.push({
        path: "/anrede/create?editContact=" + this.$route.query.contact,
      });
    },
    resetLocalStorageContactObject() {
      localStorage.removeItem("contactObject");
    },
    cancelEdit() {
      this.resetLocalStorageContactObject();
      this.$router.push({
        path: "/contacts",
      });
    },
    saveEdit() {
      this.isLoading = true;
      PutContacts(
        this.contactObject.id,
        this.contactObject,
        () => {
          this.isLoading = false;
          this.resetLocalStorageContactObject();

          this.$router.push({
            path: `/contacts`,
            quey: { source: this.$route.path },
          });
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },

    getContact(contactId) {
      GetContactsWithId(
        contactId,
        (response) => {
          if (
            localStorage.getItem("contactObject") &&
            JSON.parse(localStorage.getItem("contactObject")).id === response.id
          ) {
            this.contactObject = JSON.parse(
              localStorage.getItem("contactObject"),
            );
          } else {
            this.contactObject = response;
          }

          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    getFormOfAddress() {
      this.isLoading = true;
      this.errorObject = null;

      GetFormOfAddress(
        (response) => {
          this.anreden_items = response;
          this.getOrganisations();
        },

        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    getOrganisations() {
      this.isLoading = true;
      GetOragnisations(
        1,
        1,
        "",
        "",
        0,
        (response) => {
          //Zuerst nur eine Organisation abrufen um die Anzahl Organisationen zu bekommen
          GetOragnisations(
            response.numberOfItems,
            1,
            "",
            "",
            0,
            (response2) => {
              this.organisation_items = response2.organisations;
              this.getSupportedLanguages();
            },
            (error) => {
              this.errorObject = error;
              this.isLoading = false;
            },
          );
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    getSupportedLanguages() {
      GetFallbackLanguages(
        (response) => {
          this.communicationLanguage_items = response;
          if (this.$route.query.contact) {
            this.getContact(this.$route.query.contact);
          } else {
            this.isLoading = false;
          }
        },

        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped>
.card-body {
  margin: 20px;
}

.btn-left {
  margin-left: 20px;
}
</style>
